export const getIframeStyle = ({ tour, activeSweepGroup, sweepGroups }: { tour: any; activeSweepGroup?: any; sweepGroups: any[] }) => {
  let iframeStyle = {};
  if (tour) {
    const brightness = tour.brightness === 1 ? '' : `brightness(${tour.brightness})`;
    const saturation = tour.saturation === 1 ? '' : `saturate(${tour.saturation})`;
    const contrast = tour.contrast === 1 ? '' : `contrast(${tour.contrast})`;

    iframeStyle = {
      filter: `${brightness} ${saturation} ${contrast}`,
    };

    if (activeSweepGroup) {
      const sweepGroup = sweepGroups.find((sg: any) => sg.id === activeSweepGroup);

      if (sweepGroup) {
        const hasColorSettings = sweepGroup.brightness !== 1 || sweepGroup.saturation !== 1 || sweepGroup.contrast !== 1;

        if (hasColorSettings) {
          const sweepBrightness = sweepGroup.brightness === 1 ? '' : `brightness(${sweepGroup.brightness})`;
          const sweepSaturation = sweepGroup.saturation === 1 ? '' : `saturate(${sweepGroup.saturation})`;
          const sweepContrast = sweepGroup.contrast === 1 ? '' : `contrast(${sweepGroup.contrast})`;
          iframeStyle = {
            filter: `${sweepBrightness} ${sweepSaturation} ${sweepContrast}`,
          };
        }
      }
    }
  }
  return iframeStyle;
};
